<template>
    <nav class="navigation navbar navbar-expand-md navbar-collapse- navbar-dark bg-primary">
        <a class="navbar-brand" href="#">Mamanuc</a>

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation-menu"
                aria-controls="navigation-menu" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navigation-menu">
            <ul class="navbar-nav mr-auto nav-left">
                <li class="nav-item" v-for="link in allowedLinks" :key="link.route">
                    <RouterLink :to="link.route" class="nav-link" :class="getLinkClasses(link.route)">
                        <i :class="link.faIcon" v-if="link.faIcon !== undefined"></i>
                        {{ link.placeholder }}
                    </RouterLink>
                </li>
            </ul>

            <div class="help-button" id="help-button">
                <button type="button" class="btn btn-sm btn-primary" @click="openHelpDialog">
                    <i class="fas fa-question"></i>
                </button>
            </div>

            <div class="dropdown ml-auto nav-right">
                <a href="#" @click.prevent id="dropdownUser" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false"
                   class="nav-link dropdown-toggle">
                    <div class="row align-items-center">
                        <i v-if="user && !user.avatar" class="fas fa-user-circle fa-2x"></i>
                        <img v-if="user && user.avatar" :src="`storage/${user.avatar}`" class="image"/>
                        <span v-if="user">{{ fullNameWithRole }}</span>
                        <i class="fas fa-caret-down toggle"></i>
                    </div>
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userOptions">
                    <RouterLink to="/profile" class="dropdown-item">{{ $t('buttons.edit_profile') }}</RouterLink>
                    <a href="#" @click.prevent="handleLogout" class="dropdown-item">{{ $t('buttons.logout') }}</a>
                </div>
            </div>
        </div>

        <HelpDialog ref="helpDialog"/>
    </nav>
</template>

<script>
import { mapState, mapStores } from 'pinia';
import HelpDialog from "./dialogs/HelpDialog";
import { useRootStore } from '../stores/root';

export default {
    name: "Navigation",
    components: {
        HelpDialog
    },

    props: {
        links: {
            required: true,
            type: Array,
            default: []
        }
    },

    data() {
        return {
            link: {
                route: '',
                placeholder: '',
                faIcon: '',
                privileges: []
            }
        }
    },

    computed: {
        ...mapState(useRootStore, ["user"]),
        ...mapStores(useRootStore),
        
        allowedLinks() {
            return this.links.filter(link => {
                return link.privileges === undefined ||
                    (link.privileges.length > 0 && this.user && this.user.role && link.privileges.includes(this.user.role.key))
            })
        },

        roleName() {
            return this.user.role ? this.$t(`roles.${this.user.role.key}`) : this.$t('roles.no_role');
        },

        fullNameWithRole() {
            return `${this.user.fullName} (${this.roleName})`;
        }
    },

    methods: {
        getLinkClasses(route) {
            return {
                active: this.isCurrentRoute(route)
            }
        },

        isCurrentRoute(route) {
            return this.$route.path === route;
        },

        handleLogout() {
            this.rootStore.logoutAuth();
        },

        openHelpDialog() {
            this.getHelpText();
            $(this.$refs.helpDialog.$el).modal();
        },

        getHelpText() {
            let language = this.$refs.helpDialog.getLanguage();
            
            this.rootStore.getHelpText(this.user.role.id, this.$route.name, language)
                .then(response => {
                    this.$refs.helpDialog.setTextVideo(response["text"], response["video"]);
                });
        }
    },

    beforeUpdate() {
        this.getHelpText();
    }
}
</script>

<style scoped>
.navigation {
    padding: 0 1em;
}

.navigation .navbar-brand {
    font-weight: bold;
}

.navigation #navigation-menu {
    margin-left: 7em;
}

#navigation-menu .dropdown a {
    color: rgba(255, 255, 255, 0.5);
}

#navigation-menu .dropdown a:hover {
    color: white;
}

#navigation-menu .dropdown .dropdown-menu a {
    color: black;
}

#navigation-menu .dropdown .dropdown-toggle {
    position: relative;
}

#navigation-menu .dropdown .dropdown-toggle .row {
    margin: 0;
    padding: 0;
}

#navigation-menu .dropdown .dropdown-toggle .row .image {
    width: 30px;
    height: 30px;
    border: 1px white solid;
    border-radius: 50%;
    padding: 0;
    margin: 0 0.25em;
}

#navigation-menu .dropdown .dropdown-toggle .row > * {
    padding: 0 0.25em;
}

#navigation-menu .dropdown .dropdown-toggle::after {
    display: none !important;
}

.help-button {
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
    align-self: center;
}
</style>
